import React, { useState, useEffect } from "react";
import { Box, TextField, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { initLocationBaseObj, locationBaseTypeList } from "../../data/type"; 
import { setRRcomment, setSaveStatus } from "../../features/longPageSlice";
import { LOCAL_CONSTANT } from "../Const";

interface RRCommentProps {
    props: {
        labelName: string;
        userType: string;
    };
}

const RRComment: React.FC<RRCommentProps> = ({ props }) => {
    const dispatch = useAppDispatch();
    //調査書基本 Redux
    const objLocationBase = useAppSelector((state) => state.longPage.locationBase);
    //ロングページ保存用ステータス
    const objLongPageSaveStatus = useAppSelector((state) => state.longPage.saveStatus);
    //調査書基本の項目をReduxに登録する前に保存
    const [locationBase, setLocationBase] = useState<locationBaseTypeList>(initLocationBaseObj);

    //テキストフィールド インプット
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const inputValue = e.target.value;
        setLocationBase({...locationBase, [props.labelName]: inputValue});

        //保存ボタン活性 更新フラグ
        if (!objLongPageSaveStatus.LongPage)
            dispatch(setSaveStatus({...objLongPageSaveStatus, LongPage: true,}));
    };

    //テキストフィールドからフォーカスがずれたら、Reduxに保存
    const handleInputBlur = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>) => {
        dispatch(setRRcomment({rrComment: e.target.value, labelName: props.labelName}));
    };

    useEffect(() => {
        //ReduxをuseStateに保存
        setLocationBase(objLocationBase);
    }, [objLocationBase]);

    return (
        <Box>
            {/* テキストフィールドはリサーチのときのみ表示と常に活性化*/}
            {props.userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                <Box sx={{ marginLeft: "25px", marginBottom: "10px" }}>
                    <Typography>RRコメント</Typography>
                    <TextField
                        multiline
                        fullWidth
                        rows={2}
                        value={locationBase[props.labelName]}
                        onChange={(e) => handleInputChange(e)}
                        onBlur={(e) => handleInputBlur(e)}
                        variant="outlined"
                        sx={{ backgroundColor: "#E0F0F8" }}
                        disabled={props.userType !== LOCAL_CONSTANT.USER_TYPE.RR}
                    />
                </Box>
            )}
        </Box>
    );
};

export default RRComment;